export default function validationEmplacement(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_TO_ARCHIVE_EMPLACEMENT_WITH_ETAT_DISPOSITIF_DIFF_DEMONTE') !== -1 && messages.filter((error) => { return error.message === 'emplacement.messages.error.emplacementDispositif'; }).length === 0) {
      messages.push({
        message: 'emplacement.messages.error.emplacementDispositif',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_ARCHIVE_EMPLACEMENT_WITH_ETAT_MATERIEL_DIFF_DEMONTE') !== -1 && messages.filter((error) => { return error.message === 'emplacement.messages.error.emplacementMateriel'; }).length === 0) {
      messages.push({
        message: 'emplacement.messages.error.emplacementMateriel',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_ARCHIVE_EMPLACEMENT_WITH__ETAT_FACE_DIFF_DEMONTE') !== -1 && messages.filter((error) => { return error.message === 'emplacement.messages.error.emplacementFace'; }).length === 0) {
      messages.push({
        message: 'emplacement.messages.error.emplacementFace',
      });
    }
  });
}
